<script setup>
// Google Ads > Anahtar kelimeler
//
// Kalite puani Google'in 1-10 arasi degerlendirmesi; bos olmasi
// 'veri yetersiz' demek, sifir degil.
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import GoogleAdsKabuk from './GoogleAdsKabuk.vue';
import GoogleAdsTablo from './GoogleAdsTablo.vue';
import { getir, hataMetni } from './kopru.js';

const { t } = useI18n();
const route = useRoute();

const satirlar = ref([]);
const paraBirimi = ref('');
const yukleniyor = ref(false);
const hata = ref('');

const SUTUNLAR = [
  { alan: 'metin', anahtar: 'GOOGLE_ADS.SUTUN.KELIME', siralanabilir: true, vurgu: true },
  { alan: 'eslesme', anahtar: 'GOOGLE_ADS.SUTUN.ESLESME', tur: 'etiket', siralanabilir: true },
  { alan: 'durum', anahtar: 'GOOGLE_ADS.SUTUN.DURUM', tur: 'durum', siralanabilir: true },
  { alan: 'kalite', anahtar: 'GOOGLE_ADS.SUTUN.KALITE', tur: 'sayi', siralanabilir: true },
  { alan: 'kampanya', anahtar: 'GOOGLE_ADS.SUTUN.KAMPANYA', siralanabilir: true },
  { alan: 'harcama', anahtar: 'GOOGLE_ADS.SUTUN.HARCAMA', tur: 'para', siralanabilir: true },
  { alan: 'gosterim', anahtar: 'GOOGLE_ADS.SUTUN.GOSTERIM', tur: 'sayi', siralanabilir: true },
  { alan: 'tiklama', anahtar: 'GOOGLE_ADS.SUTUN.TIKLAMA', tur: 'sayi', siralanabilir: true },
  { alan: 'donusum', anahtar: 'GOOGLE_ADS.SUTUN.DONUSUM', tur: 'sayi', siralanabilir: true },
  { alan: 'ortalama_tiklama_maliyeti', anahtar: 'GOOGLE_ADS.SUTUN.ORT_TIKLAMA', tur: 'para', siralanabilir: true },
];

const yukle = async aralik => {
  yukleniyor.value = true;
  hata.value = '';
  try {
    const veri = await getir(route.params.accountId, 'anahtar-kelimeler', { aralik });
    satirlar.value = veri.kelimeler || [];
    paraBirimi.value = veri.para_birimi || '';
  } catch (e) {
    satirlar.value = [];
    hata.value = hataMetni(e, t('GOOGLE_ADS.HATA'));
  } finally {
    yukleniyor.value = false;
  }
};
</script>

<template>
  <GoogleAdsKabuk
    :baslik="t('GOOGLE_ADS.ANAHTAR_KELIMELER')"
    :aralik-goster="true"
    @aralik="yukle"
  >
    <div class="flex flex-col gap-3">
      <p v-if="hata" class="text-sm text-n-ruby-11">{{ hata }}</p>
      <div v-if="yukleniyor" class="flex justify-center p-10">
        <Spinner class="text-n-brand" />
      </div>
      <GoogleAdsTablo
        v-else
        :sutunlar="SUTUNLAR"
        :satirlar="satirlar"
        :para-birimi="paraBirimi"
        varsayilan-siralama="gosterim"
      />
    </div>
  </GoogleAdsKabuk>
</template>
